(function(){

  // ── ESTRELLAS EN TODA LA PAGINA ─────────────────────────
  function initStars(){
    const canvas = document.createElement('canvas');
    canvas.id = 'cy-starfield';
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:0;opacity:0.7;';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');

    function resize(){
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    const stars = Array.from({length:200}, ()=>({
      x: Math.random()*canvas.width,
      y: Math.random()*canvas.height,
      r: Math.random()*1.2+0.2,
      vx: (Math.random()-.5)*.2,
      vy: (Math.random()-.5)*.2,
      a: Math.random()*.5+.15,
      p: Math.random()*Math.PI*2
    }));

    function draw(){
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
      ctx.clearRect(0,0,canvas.width,canvas.height);
      stars.forEach(s=>{
        s.x+=s.vx; s.y+=s.vy; s.p+=0.02;
        if(s.x<0)s.x=canvas.width;  if(s.x>canvas.width)s.x=0;
        if(s.y<0)s.y=canvas.height; if(s.y>canvas.height)s.y=0;
        const a=s.a*(0.6+0.4*Math.sin(s.p));
        ctx.beginPath();
        ctx.arc(s.x,s.y,s.r,0,Math.PI*2);
        ctx.fillStyle='rgba(180,160,255,'+a+')';
        ctx.fill();
      });
      for(let i=0;i<stars.length;i++){
        for(let j=i+1;j<stars.length;j++){
          const dx=stars[i].x-stars[j].x, dy=stars[i].y-stars[j].y;
          const d=Math.sqrt(dx*dx+dy*dy);
          if(d<65){
            ctx.beginPath();
            ctx.moveTo(stars[i].x,stars[i].y);
            ctx.lineTo(stars[j].x,stars[j].y);
            ctx.strokeStyle='rgba(124,58,237,'+(0.12*(1-d/65))+')';
            ctx.lineWidth=.3;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(draw);
    }
    draw();
  }

  // ── EFECTO 3D TILT EN TARJETAS DE PRODUCTO ───────────────────────────
  function tilt3D(el){
    const shine = el.querySelector('.cy-shine');
    el.addEventListener('mousemove', e=>{
      const r=el.getBoundingClientRect();
      const x=e.clientX-r.left, y=e.clientY-r.top;
      const rx=((y-r.height/2)/r.height)*-10;
      const ry=((x-r.width/2)/r.width)*10;
      el.style.transform='perspective(500px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-4px)';
      el.style.transition='transform .08s';
      if(shine){
        shine.style.background='radial-gradient(circle at '+x+'px '+y+'px,rgba(124,58,237,0.15) 0%,transparent 65%)';
        shine.style.opacity='1';
      }
    });
    el.addEventListener('mouseleave',()=>{
      el.style.transform='perspective(500px) rotateX(0) rotateY(0) translateY(0)';
      el.style.transition='transform .35s';
      if(shine) shine.style.opacity='0';
    });
  }

  function addShineToCards(){
    const cards = document.querySelectorAll('.product-card, .product-grid__item, .collection-card');
    cards.forEach(card=>{
      card.style.position = 'relative';
      card.style.overflow = 'hidden';
      card.style.transformStyle = 'preserve-3d';
      if(!card.querySelector('.cy-shine')){
        const shine = document.createElement('div');
        shine.className = 'cy-shine';
        shine.style.cssText = 'position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .2s;border-radius:inherit;z-index:10;';
        card.appendChild(shine);
      }
      tilt3D(card);
    });
  }

  // ── EFECTO TILT EN TARJETAS DE CATEGORIA ──────────────────
  function initCategoryCards(){
    document.querySelectorAll('.gc-cat-card').forEach(card=>{
      const shine=card.querySelector('.gc-shine');
      if(!shine) return;
      card.addEventListener('mousemove', e=>{
        const r=card.getBoundingClientRect();
        const x=e.clientX-r.left, y=e.clientY-r.top;
        const rx=((y-r.height/2)/r.height)*-12;
        const ry=((x-r.width/2)/r.width)*12;
        card.style.transform='perspective(600px) rotateX('+rx+'deg) rotateY('+ry+'deg) scale(1.04)';
        card.style.transition='transform .1s';
        shine.style.background='radial-gradient(circle at '+x+'px '+y+'px,#ffffff15 0%,transparent 65%)';
        shine.style.opacity='1';
      });
      card.addEventListener('mouseleave',()=>{
        card.style.transform='perspective(600px) rotateX(0) rotateY(0) scale(1)';
        card.style.transition='transform .4s';
        shine.style.opacity='0';
      });
    });
  }

  // ── INIT ─────────────────────────────────────────────────
  function init(){
    initStars();
    setTimeout(()=>{
      addShineToCards();
      initCategoryCards();
    }, 600);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();